import type { PayloadAction } from "@reduxjs/toolkit";
import { MicOption } from "Data/Objects/Audio";
import type { AudioSettingsState } from "Interfaces";
import { createAppSlice } from "Data/Redux/Store";

const initialState: AudioSettingsState = {
	enableAudio: false,
	micOption: MicOption.BUILT_IN,
	micVolume: 10,
	speakerVolume: 10
};

export const setAudioReducer = (state: AudioSettingsState, action: PayloadAction<AudioSettingsState>) => {
	return action.payload;
};

export const getAudio = (state: AudioSettingsState) => {
	return state;
};

const audioSlice = createAppSlice({
	name: "audio",
	initialState,
	reducers: {
		setAudioAction: setAudioReducer
	},
	selectors: {
		selectAudio: getAudio
	}
});

export default audioSlice;

export const { setAudioAction } = audioSlice.actions;
export const { selectAudio } = audioSlice.selectors;
